import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const ExternalLinkIcon = ({ color, className }) => (
    <svg width="13.45" height="14.074" viewBox="0 0 13.45 14.074" xmlns="http://www.w3.org/2000/svg" className={className}>
        <g transform="translate(-426.263 -7829.769)">
            <path
                d="M8.891,2.888,6.116,0,5.751.341l2.195,2.3H0v.5H7.945L5.751,5.424l.366.353Z"
                transform="translate(430.302 7833.917)"
                fill={color}
                stroke={color}
                strokeWidth="0.75"
            />
            <path
                d="M-9536.113,13276.859v-4.578h-6.084v13.074h6.084v-4.787"
                transform="translate(9968.96 -5442.013)"
                fill="none"
                stroke={color}
                strokeWidth="1"
            />
        </g>
    </svg>
);

ExternalLinkIcon.propTypes = propTypes;
ExternalLinkIcon.defaultProps = defaultProps;

export default ExternalLinkIcon;
